import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { isNil } from "ramda";

import { GenericObject } from "../../types/generic.types";
import { User, UserRole } from "../../types/user.types";

export const initialUserState: User = {
  id: undefined,
  email: null,
  emailVerified: false,
  displayName: null,
  role: UserRole.unknown,
  loading: false,
  creationTime: null,
  reservationLastSeenAt: null,
  ordersLastSeenAt: null,
  requestsLastSeenAt: null,
  status: null,
  defaultSlotTime: 0,
  sportTypeIds: null,
  path: null,
  webviewFcmToken: null,
};

const userSlice = createSlice({
  name: "@__user",
  initialState: initialUserState,
  reducers: {
    setUserData(state: User, action: PayloadAction<GenericObject>) {
      const data = isNil(action.payload) ? initialUserState : action.payload;
      return {
        ...state,
        ...data,
      };
    },
    loadingUser(state: User, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    logout() {
      return initialUserState;
    },
  },
});

export const { setUserData, loadingUser, logout } = userSlice.actions;
export default userSlice.reducer;
